<template>
	<footer class="footer">
		<div class="container">
			<!-- Outer-Footer -->
			<div class="outer-footer-wrapper u-s-p-y-80">
				<h6>For special offers and other discount information</h6>
				<h1>Subscribe to our Newsletter</h1>
				<p>
					Subscribe to the mailing list to receive updates on promotions, new arrivals,
					discount and coupons.
				</p>
				<form class="newsletter-form" @submit.prevent="handleEmailSubmit">
					<label class="sr-only" for="newsletter-field">Enter your Email</label>
					<input
						type="email"
						id="newsletter-field"
						placeholder="Your Email Address"
						required
						v-model="email"
					/>
					<button type="submit" class="button" :disabled="loading">
						{{ loading ? "Please Wait" : "SUBMIT" }}
					</button>
				</form>
			</div>
			<!-- Outer-Footer /- -->
			<!-- Mid-Footer -->
			<div class="mid-footer-wrapper u-s-p-b-80">
				<div class="row">
					<div class="col-lg-3 col-md-3 col-sm-12">
						<div class="footer-list">
							<h6>PAGES</h6>
							<ul>
								<li>
									<router-link :to="{name: 'Home'}">Home</router-link>
								</li>
								<li>
									<router-link :to="{name: 'PostRequirements'}">Post Requirements</router-link>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-lg-6 col-md-6 col-sm-12">
						<div class="footer-list">
							<h6>USER INFORMATION</h6>
							<ul>
								<li>
									<router-link :to="{name: 'Home'}">Shop</router-link>
								</li>
								<li>
									<router-link :to="{name: 'Wishlist'}">Wishlist</router-link>
								</li>
								<li>
									<router-link :to="{name: 'Cart'}">Cart</router-link>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12">
						<div class="footer-list">
							<h6>Address</h6>
							<ul>
								<li>
									<i class="fas fa-location-arrow u-s-m-r-9"></i>
									<span>H Block, Sector 63, Noida, UP - 201301</span>
								</li>
								<li>
									<a href="tel:+919874671880">
										<i class="fas fa-phone u-s-m-r-9"></i>
										<span>9874671880</span>
									</a>
								</li>
								<li>
									<a href="mailto:contact@domain.com">
										<i class="fas fa-envelope u-s-m-r-9"></i>
										<span> iswitch@calsob.com</span>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<!-- Mid-Footer /- -->
			<!-- Bottom-Footer -->
			<div class="bottom-footer-wrapper">
				<div class="social-media-wrapper">
					<ul class="social-media-list">
						<li>
							<a href="#">
								<i class="fab fa-facebook-f"></i>
							</a>
						</li>
						<li>
							<a href="#">
								<i class="fab fa-twitter"></i>
							</a>
						</li>
						<li>
							<a href="#">
								<i class="fab fa-google-plus-g"></i>
							</a>
						</li>
						<li>
							<a href="#">
								<i class="fas fa-rss"></i>
							</a>
						</li>
						<li>
							<a href="#">
								<i class="fab fa-pinterest"></i>
							</a>
						</li>
						<li>
							<a href="#">
								<i class="fab fa-linkedin-in"></i>
							</a>
						</li>
						<li>
							<a href="#">
								<i class="fab fa-youtube"></i>
							</a>
						</li>
					</ul>
				</div>
				<p class="copyright-text">
					Copyright &copy; {{ new Date().getFullYear() }} <a href="/">CalsoB</a> All
					Right Reserved
				</p>
			</div>
		</div>
		<!-- Bottom-Footer /- -->
	</footer>
</template>

<script>
	import axios from "axios";
	import {useToast} from "vue-toastification";
	export default {
		data() {
			return {
				email: "",
				loading: false,
			};
		},
		methods: {
			async handleEmailSubmit() {
				this.loading = true;
				const url = process.env.VUE_APP_API_URL + "/api/subscribe";
				try {
					let {data} = await axios.post(url, {
						email: this.email,
					});
					useToast().success("Thank You For Subscribing!", {timeout: 3000});
					this.loading = false;
				} catch (error) {
					console.log(error);
					this.loading = false;
				}
			},
		},
	};

	if (process.env.NODE_ENV == "production") {
		var Tawk_API = Tawk_API || {},
			Tawk_LoadStart = new Date();
		(function () {
			var s1 = document.createElement("script"),
				s0 = document.getElementsByTagName("script")[0];
			s1.async = true;
			s1.src = "https://embed.tawk.to/5ce27153d07d7e0c63946d47/default";
			s1.charset = "UTF-8";
			s1.setAttribute("crossorigin", "*");
			s0.parentNode.insertBefore(s1, s0);
		})();
	}
</script>

<style></style>
